import { jsx as _jsx, jsxs as _jsxs } from 'react/jsx-runtime.js';
import { Base, Flex, Heading } from '@stepstone-genesis/components';
import { Trans, useTranslation } from '@stepstone-platform/i18n';
import { useActiveMediaQuery } from '@stepstone-genesis/hooks-use-active-media-query';
import { BrandLogo } from './BrandLogo.js';
export const LoggedInContent = () => {
    const { t } = useTranslation();
    const { matches } = useActiveMediaQuery({
        breakpoints: [600, 900, 1200, 1800],
        keys: ['xs', 'small', 'medium', 'large', 'xl'],
    });
    const isMobile = matches.xs;
    const headingLabel = isMobile
        ? t('loginregistration.fullscreenModalContent.loggedIn.mobileHeader')
        : t('loginregistration.fullscreenModalContent.loggedIn.header');
    return (_jsxs(Flex, { flxDirection: 'column', pb: ['spaceNone', 'spaceXl'], children: [isMobile ? _jsx(BrandLogo, {}) : null, _jsxs(Flex, { flxDirection: 'column', gap: ['spaceM', 'spaceL', 'spaceXl'], pt: ['spaceXxl', 'spaceXl'], pb: 'spaceM', children: [_jsx(Heading, { as: "h1", variant: 'hero', children: headingLabel }), _jsx(Heading, { as: "h2", variant: 'title', children: _jsx(Trans, { i18nKey: 'loginregistration.fullscreenModalContent.loggedIn.underHeader', components: [
                                _jsx(Base, { as: 'span', sx: { color: 'colorActionableDefault' } }, 0),
                                _jsx("br", {}, 1),
                            ] }) })] })] }));
};
//# sourceMappingURL=LoggedInContent.js.map